import tw from 'tailwind-styled-components'

export const CheckBoxContainer = tw.div`
    flex
    items-center
    gap-2
`
